import React from 'react';
import { appContext } from '../../util/decorators';
import Picture from '../Picture.jsx';

const DATE_FORMAT = 'D MMM';

@appContext
export default class LiveStreamListing extends React.PureComponent {
  getFormattedStartTime(startTime) {
    const t = this.context.app.t;
    return startTime.calendar(null, {
      sameDay: `[${t('LiveStreamListing.today')}]`,
      nextDay: `[${t('LiveStreamListing.tomorrow')}]`,
      sameElse: `${DATE_FORMAT}`,
      nextWeek: `${DATE_FORMAT}`,
    });
  }

  isLive(startTime) {
    return this.context.app.serverTime().valueOf() > startTime.valueOf();
  }

  getTimelineWidth(startTime, endTime) {
    const elapsedTime = this.context.app.serverTime().valueOf() - startTime.valueOf();
    const duration = endTime.valueOf() - startTime.valueOf();

    return Math.floor((elapsedTime / duration) * 100) + '%';
  }

  render() {
    const t = this.context.app.t;

    return (
      <div>
        {
          this.props.liveStreams && this.props.liveStreams.length > 0 &&
            <ul className="livestream-list">
              {
                this.props.liveStreams.map((stream, index) => {
                  const isLive = this.isLive(stream.startTime);
                  return (
                    <a key={stream.url} href={stream.url} className="livestream-list-item" target="_blank">
                      <li>
                        {
                          index === 0 && stream.picture &&
                            <span className="video-thumbnail">
                              <Picture src={stream.picture} alt={stream.title} size={3}/>
                            </span>
                        }
                        <div className="stream-info">
                          <div className="stream-time">
                            <div className="startTime">{stream.startTime.format('HH:mm')}</div>
                            <div className="endTime">{stream.endTime.format('HH:mm')}</div>
                          </div>
                          <div>
                            <h6>{stream.title}</h6>
                            <p className="subtitle">{stream.subTitle || stream.league}</p>
                          </div>
                        </div>
                        {
                          stream.startTime ?
                            isLive ?
                              <span className="btn-live no-user-select">{t('LiveStreamListing.live')}</span>
                            :
                              <span className="date">{this.getFormattedStartTime(stream.startTime)}</span>
                          :
                            ''
                        }
                        { isLive && <div className="timeline" style={{width: this.getTimelineWidth(stream.startTime, stream.endTime)}} />}
                      </li>
                    </a>
                  );
                })
              }
            </ul>
        }
      </div>
    );
  }
}

LiveStreamListing.propTypes = {
  liveStreams: React.PropTypes.arrayOf(React.PropTypes.shape({
    title: React.PropTypes.string.isRequired,
    subTitle: React.PropTypes.string,
    picture: React.PropTypes.string,
    url: React.PropTypes.string.isRequired,
    startTime: React.PropTypes.object.isRequired,
  })),
};



// WEBPACK FOOTER //
// ./src/component/Sidebar/LiveStreamListing.jsx